import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom'
import { FaFacebook,FaLinkedin,FaYoutube } from "react-icons/fa";

function Footer() {
    let year = new Date().getFullYear();
  return (
    <div className="Footer">
        <div className=" d-flex flex-row justify-content-center py-5">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 d-flex flex-column align-items-center">
                <h3 style={{borderBottom: '2px solid #F18F01'}}>CONTACT</h3>
                <ul>
                    <li>
                        <p>
                            Shk. Rashid Bin Saeed St.
                            <br/>
                            C28 - 1001
                            <br/>
                            P.O. Box: 62902
                            <br/>
                            Abu Dhabi - UAE
                        </p>
                    </li>
                    <li>
                        <p>Phone: <Link target="_blank" to="tel:+971504500215">+971 50 4500215</Link></p>
                    </li>
                    <li>
                        <p>Email: <Link target="_blank" to="mailto:info@orbinexum.com">info@orbinexum.com</Link>
                            <br></br><Link target="_blank" to="mailto:contact@orbinexum.com">contact@orbinexum.com</Link>
                        </p>
                    </li>


                </ul>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 d-flex flex-column align-items-center second-footer-part">
                <h3 style={{borderBottom: '2px solid #F18F01'}}>SOCIAL MEDIA</h3>
                <ul className='d-flex flex-row gap-3'>
                    <li>
                        <Link target="_blank" to="https://www.facebook.com/VenerablePatriarchDouaihyOfficialPage"><FaFacebook /></Link>
                    </li>
                    <li>
                        <Link target="_blank" to="https://www.facebook.com/VenerablePatriarchDouaihyOfficialPage"><FaLinkedin /></Link>
                    </li>
                    <li>
                        <Link target="_blank" to="https://www.facebook.com/VenerablePatriarchDouaihyOfficialPage"><FaYoutube /></Link>
                    </li>
                </ul>
            </div>
        </div>
        <div className="lower-footer">
            <div className="copyright" style={{textAlign:'center'}}>
                <p>Copyright © {year} by OrbiNexum. All rights reserved.</p>
            </div>
        </div>
    </div>
  );
}

export default Footer;